import { BANNERS, VIDEOS, REGION_LOOKS, WIDGETS } from 'constants/routes';
import { ADMIN, RETAILER } from 'constants/roles';

export const contentManagerTabs = [
  {
    key: REGION_LOOKS,
    label: 'Looks.title',
    description: 'Looks.adminTableTitle',
    namespace: 'ownerPortal',
    roles: [ADMIN],
  },
  {
    key: WIDGETS,
    label: 'widgets.listTitle',
    description: 'widgets.listDescription',
    namespace: 'pages',
    roles: [ADMIN, RETAILER],
  },
  {
    key: BANNERS,
    label: 'contentManager.banners.tabTitle',
    description: 'contentManager.banners.description',
    namespace: 'pages',
    roles: [ADMIN],
  },
  {
    key: VIDEOS,
    label: 'contentManager.videos.tabTitle',
    description: 'contentManager.videos.description',
    namespace: 'pages',
    roles: [ADMIN],
  },
];

export const getAvailableContentManagerTabs = (role) =>
  contentManagerTabs.filter((tab) => !tab.roles || tab.roles.includes(role));

export const getContentManagerTabLabel = (tab, tPages, tOwnerPortal) =>
  tab.namespace === 'ownerPortal' ? tOwnerPortal(tab.label) : tPages(tab.label);

export const getContentManagerActiveTab = (pathname, tabs = contentManagerTabs) =>
  tabs.find((tab) => pathname.startsWith(tab.key)) ?? tabs[0];
